module.exports = require('./helpers/bundle-url').getBundleURL('e8Iy0') + "logo.c51670a8.svg";